import { render, staticRenderFns } from "./ConfirmDeleteWorkDialog.vue?vue&type=template&id=15b67a5e&"
import script from "./ConfirmDeleteWorkDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteWorkDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports